<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12" sm="12">
        <iq-card>
        <template v-slot:headerTitle>
            <h4 v-if="!item" class="card-title">{{ $t('ds_exam_management.curriculum_wise_progress_setting') }}</h4>
            <h4 v-else class="card-title">{{ $t('ds_exam_management.curriculum_wise_progress_setting') + ' ' + $t('globalTrans.modify') }}</h4>
        </template>
        <template v-slot:headerAction>
            <router-link to="curriculum-wise-progress" :class="'btn btn-primary text-light'"><i class="ri-file-text-line"></i>{{ $t('ds_student_management.individual_assessment') + ' ' + $t('globalTrans.list') }}</router-link>
        </template>
          <template v-slot:body>
            <b-row>
              <b-col lg="12" sm="12">
                <ValidationObserver ref="form" v-slot="{ handleSubmit, reset }">
                  <b-form  @submit.prevent="handleSubmit(getAssingedCurricular)" @reset.prevent="reset" enctype="multipart/form-data">
                    <b-overlay :show="unitLoad">
                        <b-col lg="12" sm="12">
                            <iq-card>
                                <template v-slot:body>
                                    <b-row>
                                        <b-col lg="6" sm="12">
                                            <ValidationProvider name="Organization" vid="org_id" rules="required|min_value:1">
                                                <b-form-group
                                                    class="row"
                                                    label-cols-sm="4"
                                                    label-for="organiation_id"
                                                    slot-scope="{ valid, errors }"
                                                    >
                                                    <template v-slot:label>
                                                        {{$t('globalTrans.organization')}} <span class="text-danger">*</span>
                                                    </template>
                                                    <b-form-select
                                                    plain
                                                    @change="emptyCurriculum()"
                                                    v-model="assessment.org_id"
                                                    :options="orgList"
                                                    id="organiation_id"
                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                    >
                                                    <template v-slot:first>
                                                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                    </template>
                                                    </b-form-select>
                                                    <div class="invalid-feedback">
                                                    {{ errors[0] }}
                                                    </div>
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-col>
                                        <b-col lg="6" sm="12">
                                            <ValidationProvider name="Institute Type" vid="office_type_id" rules="required|min_value:1">
                                                <b-form-group
                                                    class="row"
                                                    label-cols-sm="4"
                                                    label-for="office_type_id"
                                                    slot-scope="{ valid, errors }"
                                                    >
                                                    <template v-slot:label>
                                                        {{$t('child_configuration.institute_type')}} <span class="text-danger">*</span>
                                                    </template>
                                                    <b-form-select
                                                    plain
                                                    @change="emptyCurriculum()"
                                                    v-model="assessment.office_type_id"
                                                    :options="officeTypeList"
                                                    id="office_type_id"
                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                    >
                                                    <template v-slot:first>
                                                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                    </template>
                                                    </b-form-select>
                                                    <div class="invalid-feedback">
                                                    {{ errors[0] }}
                                                    </div>
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-col>
                                        <b-col lg="6" sm="12">
                                            <ValidationProvider name="Institute Name" vid="office_id" rules="required|min_value:1">
                                                <b-form-group
                                                    class="row"
                                                    label-cols-sm="4"
                                                    label-for="office_id"
                                                    slot-scope="{ valid, errors }"
                                                    >
                                                    <template v-slot:label>
                                                        {{$t('child_configuration.institute_name')}} <span class="text-danger">*</span>
                                                    </template>
                                                    <b-form-select
                                                    plain
                                                    @change="emptyCurriculum()"
                                                    v-model="assessment.office_id"
                                                    :options="officeList"
                                                    id="office_id"
                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                    >
                                                    <template v-slot:first>
                                                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                    </template>
                                                    </b-form-select>
                                                    <div class="invalid-feedback">
                                                    {{ errors[0] }}
                                                    </div>
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-col>
                                        <b-col lg="6" sm="12">
                                            <ValidationProvider name="Class" vid="class_id" rules="required|min_value:1">
                                                <b-form-group
                                                    class="row"
                                                    label-cols-sm="4"
                                                    label-for="class_id"
                                                    slot-scope="{ valid, errors }"
                                                >
                                                    <template v-slot:label>
                                                        {{$t('ds_institute_management.class')}} <span class="text-danger">*</span>
                                                    </template>
                                                    <b-form-select
                                                        plain
                                                        @change="emptyCurriculum()"
                                                        v-model="assessment.class_id"
                                                        id="class_id"
                                                        :options="classList"
                                                        :state="errors[0] ? false : (valid ? true : null)"
                                                    >
                                                    <template v-slot:first>
                                                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                    </template>
                                                    </b-form-select>
                                                    <div class="invalid-feedback">
                                                        {{ errors[0] }}
                                                    </div>
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-col>
                                        <b-col lg="6" sm="12">
                                            <b-spinner v-if="studentSpinLoader" class="overlay" variant="success" small label="Spinning"></b-spinner>
                                            <ValidationProvider name="Student ID" vid="student_id" rules="required|min_value:1">
                                                <b-form-group
                                                    class="row"
                                                    label-cols-sm="4"
                                                    label-for="student_id"
                                                    slot-scope="{ valid, errors }"
                                                >
                                                    <template v-slot:label>
                                                        {{$t('ds_student_management.student_name')}} <span class="text-danger">*</span>
                                                    </template>
                                                    <b-form-select
                                                        plain
                                                        @change="emptyCurriculum()"
                                                        v-model="assessment.applicant_id"
                                                        id="student_id"
                                                        :options="studentList"
                                                        :state="errors[0] ? false : (valid ? true : null)"
                                                    >
                                                        <template v-slot:first>
                                                            <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                        </template>
                                                    </b-form-select>
                                                    <div class="invalid-feedback">
                                                        {{ errors[0] }}
                                                    </div>
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-col>
                                        <b-col lg="6" sm="12" md="4">
                                            <ValidationProvider name="Year" vid="year_id" rules="required|min_value:1">
                                                <b-form-group
                                                    class="row"
                                                    label-cols-sm="4"
                                                    label-for="year_id "
                                                    slot-scope="{ valid, errors }"
                                                    >
                                                    <template v-slot:label>
                                                    {{$t('globalTrans.year')}} <span class="text-danger">*</span>
                                                    </template>
                                                    <b-form-select
                                                    plain
                                                    @change="emptyCurriculum()"
                                                    v-model="assessment.year"
                                                    id="year_id"
                                                    :options="yearList"
                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                    >
                                                    <template v-slot:first>
                                                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                    </template>
                                                    </b-form-select>
                                                    <div class="invalid-feedback">
                                                        {{ errors[0] }}
                                                    </div>
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-col>
                                        <b-col lg="6" sm="12">
                                            <ValidationProvider name="IEP Slot" vid="slot" rules="required|min_value:1">
                                                <b-form-group
                                                    class="row"
                                                    label-cols-sm="4"
                                                    label-for="slot "
                                                    slot-scope="{ valid, errors }"
                                                >
                                                    <template v-slot:label>
                                                        {{$t('ds_student_management.slot')}} <span class="text-danger">*</span>
                                                    </template>
                                                    <b-form-select
                                                        plain
                                                        @change="emptyCurriculum()"
                                                        v-model="assessment.slot_id"
                                                        id="slot_id"
                                                        :options="IepSlotList"
                                                        :state="errors[0] ? false : (valid ? true : null)"
                                                    >
                                                        <template v-slot:first>
                                                            <b-form-select-option :value="0" disabled>{{$t('globalTrans.select')}}</b-form-select-option>
                                                        </template>
                                                    </b-form-select>
                                                    <div class="invalid-feedback">
                                                        {{ errors[0] }}
                                                    </div>
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-col>
                                        <b-col  md="12">
                                            <b-button type="submit" variant="primary">{{ $t('globalTrans.search')}}</b-button>
                                        </b-col>
                                    </b-row>
                                </template>
                            </iq-card>
                        </b-col>
                    </b-overlay>
                  </b-form>
                </ValidationObserver>
              </b-col>
              <b-col v-if="Object.values(curriculums).length > 0" lg="12" sm="12">
                <ValidationObserver ref="form1" v-slot="{ handleSubmit, reset }">
                  <b-form  @submit.prevent="handleSubmit(register)" @reset.prevent="reset" enctype="multipart/form-data">
                    <b-overlay :show="unitLoad">
                        <b-col lg="12" sm="12">
                            <iq-card>
                                <template v-slot:body>
                                    <div class="bg-success py-2 mb-2 rounded-top">
                                        <h5 v-if="!item" class="text-white text-center"> {{ $t('ds_exam_management.curriculum_wise_progress') + ' ' + $t('globalTrans.entry') }}</h5>
                                        <h5 v-else class="text-white text-center"> {{ $t('ds_exam_management.curriculum_wise_progress') + ' ' + $t('globalTrans.modify') }}</h5>
                                    </div>
                                    <b-row>
                                        <!-- <b-col xl="12" lg="12" md="12" sm="12" xs="12">
                                            <p><strong>{{ $t('ds_student_management.scoring_process') }}</strong>{{ $t('ds_student_management.score_process') }}</p>
                                        </b-col> -->
                                        <b-col lg="12" sm="12">
                                            <b-table-simple bordered small>
                                                <tbody>
                                                    <span hidden>{{ $i = 0 }}</span>
                                                    <b-tr>
                                                        <b-th class="align-middle text-center">{{ $t('ds_student_management.skill_name') }}</b-th>
                                                        <b-th class="align-middle">
                                                            <b-list-group flush class="list">
                                                                <b-list-group-item class="bg-light px-2 py-0">
                                                                    <b-row align-v="center">
                                                                        <b-col md="auto">
                                                                        </b-col>
                                                                        <b-col>
                                                                            <small>{{ $t('ds_student_management.scheduled_work') }}</small>
                                                                        </b-col>
                                                                        <b-col>
                                                                            <small>{{ $t('ds_student_management.previous_status') }}</small>
                                                                        </b-col>
                                                                        <b-col>
                                                                            <small>{{ $t('ds_student_management.current_status') }}</small>
                                                                        </b-col>
                                                                        <b-col>
                                                                            <small>{{ $t('ds_student_management.comments_evaluation') }}</small>
                                                                        </b-col>
                                                                    </b-row>
                                                                </b-list-group-item>
                                                            </b-list-group>
                                                        </b-th>
                                                    </b-tr>
                                                    <b-tr v-for="(type, index) in curriculums" :key="index">
                                                        <b-th class="align-top text-center" width="20%">{{ $i18n.locale === 'bn' ? type.type_name_bn : type.type_name }}</b-th>
                                                        <b-td>
                                                            <b-list-group flush class="list">
                                                                <b-list-group-item v-for="(item, indx) in type.activities" :key="indx" class="px-2 py-1">
                                                                    <span hidden>{{ $i++ }}</span>
                                                                    <b-row align-v="center" >
                                                                        <b-col md="auto">
                                                                            <!-- <span>{{ $n($i) + '.' }}</span> -->
                                                                            <b-form-checkbox
                                                                                :id="'checkbox-1'+$i"
                                                                                v-model="item.checked"
                                                                                @change="getAverageActivity(item, indx, index)"
                                                                                name="checkbox-1"
                                                                                :value=1
                                                                                :unchecked-value=0
                                                                            >
                                                                            </b-form-checkbox>
                                                                        </b-col>
                                                                        <b-col>
                                                                            <h6 class="mb-0">
                                                                                <span>{{ $i18n.locale === 'bn' ? item.activity_name_bn : item.activity_name }}</span>
                                                                            </h6>
                                                                        </b-col>
                                                                        <b-col>
                                                                                <b-spinner
                                                                                    v-if="item.checked === 1 && item.average_marks === ''"
                                                                                    class="overlay"
                                                                                    variant="success"
                                                                                    small label="Spinning"
                                                                                    style="top: 0px; left: auto; position: inherit"
                                                                                >
                                                                                </b-spinner>
                                                                                <h6 v-if="item.average_marks" class="mb-0">{{ $n(item.average_marks, { useGrouping: false }) }}</h6>
                                                                                <h6 v-if="!item.checked" class="mb-0">-</h6>
                                                                        </b-col>
                                                                        <b-col>
                                                                            <h6 v-if="item.average_marks" class="mb-0">
                                                                                <!-- <ValidationProvider name="Marks" :vid="'marks'+$i" :rules="`required|numeric|max_value:6|min_value:${item.average_marks}`"> -->
                                                                                <ValidationProvider name="Marks" :vid="'marks'+$i" :rules="`required|numeric|max_value:6`">
                                                                                    <b-form-group
                                                                                        class="row mb-0 w-100"
                                                                                        label-for="marks"
                                                                                        slot-scope="{ valid, errors }"
                                                                                    >
                                                                                        <b-form-input
                                                                                            style="height: 30px"
                                                                                            :id="'marks' + $i"
                                                                                            @input="getActivityStatus(item)"
                                                                                            v-model="item.marks"
                                                                                            :state="errors[0] ? false : (valid ? true : null)"
                                                                                        ></b-form-input>
                                                                                        <div class="invalid-feedback">
                                                                                            {{ errors[0] }}
                                                                                        </div>
                                                                                    </b-form-group>
                                                                                </ValidationProvider>
                                                                            </h6>
                                                                            <h6 v-else>-</h6>
                                                                        </b-col>
                                                                        <b-col>
                                                                            <h6 v-if="item.remarks" class="mb-0">
                                                                                <span v-if="item.remarks == 'v_good'">{{ $i18n.locale === 'en' ? 'Very good' : 'খুব ভাল' }}</span>
                                                                                <span v-else-if="item.remarks == 'good'">{{ $i18n.locale === 'en' ? 'Good' : 'ভাল' }}</span>
                                                                                <span v-else-if="item.remarks == 'satis'">{{ $i18n.locale === 'en' ? 'Satisfactory' : 'সন্তোষজনক' }}</span>
                                                                                <span v-else>{{ $i18n.locale === 'en' ? 'Need to improve' : 'উন্নতি করতে হবে' }}</span>
                                                                            </h6>
                                                                            <h6 v-else>-</h6>
                                                                        </b-col>
                                                                    </b-row>
                                                                </b-list-group-item>
                                                            </b-list-group>
                                                        </b-td>
                                                    </b-tr>
                                                </tbody>
                                            </b-table-simple>
                                        </b-col>
                                    </b-row>
                                    <div class="row">
                                        <div class="col-sm-3"></div>
                                        <div class="col text-right">
                                            <b-button type="submit" variant="primary" class="mr-2">{{ saveBtnName }}</b-button>
                                            &nbsp;
                                            <b-button variant="danger" @click="cancel()">{{ $t('globalTrans.cancel') }}</b-button>
                                        </div>
                                    </div>
                                </template>
                            </iq-card>
                        </b-col>
                    </b-overlay>
                  </b-form>
                </ValidationObserver>
              </b-col>
            </b-row>
          </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { core } from '@/config/pluginInit'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import RestApi, { disabilitySchoolServiceBaseUrl } from '@/config/api_config'
import { curriculumProgressStoreApi, curriculumProgressUpdateApi, studentInfo, avgCurriculumProgressApi, getStudentCurricularApi } from '../../api/routes'
import flatpickr from 'flatpickr'

export default {
  props: ['item'],
  components: {
    ValidationObserver,
    ValidationProvider
  },
  data () {
    return {
      unitLoad: false,
      saveBtnName: this.item ? this.$t('globalTrans.update') : this.$t('globalTrans.save'),
      assessment: {
          year: 0,
          org_id: 0,
          office_type_id: 0,
          office_id: 0,
          class_id: 0,
          slot_id: 0,
          applicant_id: 0,
          is_progress: 1
      },
      curriculums: [],
      studentSpinLoader: false,
      tmpStudentList: [],
      studentList: [],
      officeTypeList: [],
      officeList: [],
      avgSpin: false
    }
  },
  created () {
    this.assessment.org_id = this.$store.state.dataFilters.orgId
    this.assessment.office_type_id = this.$store.state.dataFilters.officeTypeId
    this.assessment.office_id = this.$store.state.dataFilters.officeId
    if (this.item) {
        this.assessment.year = this.item.year
        this.assessment.org_id = this.item.org_id
        this.assessment.office_type_id = this.item.office_type_id
        this.assessment.office_id = this.item.office_id
        this.assessment.class_id = this.item.class_id
        this.assessment.slot_id = this.item.iep_slot_id
        this.assessment.applicant_id = this.item.applicant_id
        this.getAssingedCurricular()
    }
  },
  mounted () {
    core.index()
    flatpickr('.date-picker', {})
  },
  computed: {
    examTypeList: function () {
        return this.$store.state.DisabilitySchoolService.commonObj.examTypeList.filter(item => item.status === 1)
    },
    classList: function () {
        return this.$store.state.DisabilitySchoolService.commonObj.classList.filter(item => item.status === 1)
    },
    IepSlotList: function () {
        return this.$store.state.DisabilitySchoolService.commonObj.IepSlotList.filter(item => item.status === 1)
    },
    yearList: function () {
        return this.$store.state.DisabilitySchoolService.commonObj.yearList.map(item => {
            if (this.$i18n.locale === 'bn') {
                return { value: item, text: this.$n(item, { useGrouping: false }) }
            } else {
                return item
            }
        })
    },
    orgList: function () {
        return this.$store.state.commonObj.organizationProfileList.filter(item => item.status === 0)
    },
    currentLocale () {
        return this.$i18n.locale
    }
  },
  watch: {
    'assessment.org_id': function (newVal, oldVal) {
        this.getOfficeTypeList()
        if (this.assessment.office_id && this.assessment.office_type_id && this.assessment.class_id && !this.item) {
            this.getStudentData()
        }
    },
    'assessment.office_type_id': function (newVal, oldVal) {
        this.getOfficeList()
        if (this.assessment.org_id && this.assessment.office_id && this.assessment.class_id && !this.item) {
            this.getStudentData()
        }
    },
    'assessment.office_id': function (newVal, oldVal) {
        if (this.assessment.org_id && this.assessment.office_type_id && this.assessment.class_id && !this.item) {
            this.getStudentData()
        }
    },
    'assessment.class_id': function (newVal, oldVal) {
        this.getStudentData()
    },
    currentLocale: function (newVal, oldVal) {
        if (newVal !== oldVal) {
            if (this.assessment.org_id) {
                this.getOfficeTypeList()
            }
            if (this.assessment.office_type_id) {
                this.getOfficeList()
            }
            this.getStudentList()
        }
    }
  },
  methods: {
    cancel () {
        this.$router.push({ name: 'disability_school_service.exam_and_result_management.curriculum_wise_progress' })
    },
    emptyCurriculum () {
        this.curriculums = []
    },
    getActivityStatus (item) {
        if (parseInt(item.marks) === 6) {
            item.remarks = 'v_good'
        } else if (parseInt(item.marks) < 6 && parseInt(item.marks) >= 4) {
            item.remarks = 'good'
        } else if (parseInt(item.marks) < 4 && parseInt(item.marks) >= 1) {
            item.remarks = 'satis'
        } else {
            item.remarks = 'bad'
        }
    },
    getAverageActivity (item, indx, index) {
        if (item.checked === 1) {
            this.avgSpin = true
            const avgSearch = {
                id: item.id,
                curricular_activity_id: item.curricular_activity_id
            }
            RestApi.getData(disabilitySchoolServiceBaseUrl, avgCurriculumProgressApi, avgSearch).then(response => {
                if (response.success) {
                    this.curriculums[index].activities[indx].average_marks = parseInt(response.average)
                } else {
                    this.curriculums[index].activities[indx].average_marks = ''
                }
                this.avgSpin = false
            })
        } else {
            this.curriculums[index].activities[indx].average_marks = ''
            this.curriculums[index].activities[indx].marks = ''
            this.curriculums[index].activities[indx].remarks = ''
        }
    },
    getAssingedCurricular () {
        this.unitLoad = true
        RestApi.getData(disabilitySchoolServiceBaseUrl, getStudentCurricularApi, this.assessment).then(response => {
            if (response.success) {
                this.curriculums = this.getRelationalData(response.data)
            }
            this.unitLoad = false
        })
    },
    getRelationalData (Obj) {
        const listData = Object.keys(Obj).map(key => {
            const tmpType = this.$store.state.DisabilitySchoolService.commonObj.curricularTypeList.find(el => el.value === parseInt(key))
            const newData = {
                type_name: tmpType !== undefined ? tmpType.text_en : '',
                type_name_bn: tmpType !== undefined ? tmpType.text_bn : '',
                curricular_type_id: key
            }
            this.assessment.edu_plan_id = Obj[key][0].edu_main_id
            const arryList = Obj[key].map(item => {
                const activityData = Object.assign({
                    curricular_activity_id: item.curricular_activity_id,
                    activity_name: item.curricular_activity.activity_name,
                    activity_name_bn: item.curricular_activity.activity_name_bn,
                    // edu_main_id: item.edu_main_id,
                    id: item.id,
                    checked: 0,
                    average_marks: '',
                    marks: '',
                    remarks: ''
                })
                // code for edit only
                if (this.item) {
                    const actObj = this.item.details.find(act => act.curricular_activity_id === item.curricular_activity_id)
                    if (actObj) {
                        activityData.checked = 1
                        activityData.average_marks = actObj.average_marks
                        activityData.marks = actObj.marks
                        activityData.remarks = actObj.remarks
                    }
                }
                return activityData
            })
            newData.activities = arryList
            return newData
        })
        return listData
    },
    async getStudentData () {
        this.studentSpinLoader = true
        let result = null
        result = await RestApi.postData(disabilitySchoolServiceBaseUrl, studentInfo, { office_id: this.assessment.office_id, class_id: this.assessment.class_id })
        if (result.success) {
            this.studentSpinLoader = false
            this.tmpStudentList = result.data
            this.getStudentList()
        }
    },
    getStudentList () {
        this.studentList = this.tmpStudentList.map(item => {
            if (this.$i18n.locale === 'en') {
                return Object.assign({ value: item.value, text: item.text_en + ' (Roll-' + item.student_id + ')' })
            } else {
                return Object.assign({ value: item.value, text: item.text_bn + ' (রোল-' + this.$n(item.student_id, { useGrouping: false }) + ')' })
            }
        })
    },
    getOfficeTypeList () {
        this.officeTypeList = this.$store.state.commonObj.officeTypeList.filter(item => item.status === 0 && item.org_id === this.assessment.org_id).map(obj => {
            if (this.$i18n.locale === 'bn') {
                return { value: obj.value, text: obj.text_bn }
            } else {
                return { value: obj.value, text: obj.text_en }
            }
        })
    },
    getOfficeList () {
        this.officeList = this.$store.state.commonObj.officeList.filter(item => item.status === 0 && item.office_type_id === this.assessment.office_type_id).map(obj => {
            if (this.$i18n.locale === 'bn') {
                return { value: obj.value, text: obj.text_bn }
            } else {
                return { value: obj.value, text: obj.text_en }
            }
        })
    },
    async register () {
        this.unitLoad = true
        this.$store.dispatch('mutateCommonProperties', { loading: true })
        let result = null
        this.assessment.curriculums = this.curriculums
        const loadinState = { loading: false, listReload: true }
        if (this.item) {
            result = await RestApi.putData(disabilitySchoolServiceBaseUrl, `${curriculumProgressUpdateApi}/${this.item.id}`, this.assessment)
        } else {
            result = await RestApi.postData(disabilitySchoolServiceBaseUrl, curriculumProgressStoreApi, this.assessment)
        }
        this.$store.dispatch('mutateCommonProperties', loadinState)

        if (result.success) {
            if (result.notification && this.$store.state.emitNotification) {
                const notification = result.notification
                this.$socket.emit('send-notification', notification)
            }
            this.$toast.success({
                title: this.$t('globalTrans.success'),
                message: this.item ? this.$t('globalTrans.update_msg') : this.$t('globalTrans.save_msg'),
                color: '#D6E09B'
            })
            this.unitLoad = false
            this.$router.push({ path: '/disability-school-service/exam-and-result-management/curriculum-wise-progress' })
        } else {
            this.unitLoad = false
            this.$toast.error({
                title: result.message,
                message: ''
            })
            this.$refs.form1.setErrors(result.errors)
        }
    }
  }
}
</script>
<style scoped>
.overlay {
    position: absolute;
    left: 65%;
    z-index: 9999;
    top: 10px;
    text-align: center;
}
</style>
